"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.myApi = void 0;
const updateMyProfile = {
    method: "PUT",
    url: "/my",
    reducer: resp => resp,
    errReducer: resp => resp,
};
const getMyProfile = {
    method: "GET",
    url: "/my",
    reducer: resp => resp,
    errReducer: resp => resp,
};
const getMyCertifiedTrainingIds = {
    method: "GET",
    url: "/my/certified-training-ids/valid",
    reducer: resp => resp,
    errReducer: resp => resp,
};
exports.myApi = {
    updateMyProfile,
    getMyProfile,
    getMyCertifiedTrainingIds,
};
//# sourceMappingURL=my.js.map